import { makeStyles } from '@material-ui/core'
import { Theme } from 'styling/theme'

export const useStyles = makeStyles((theme: Theme) => ({
    list: {
        margin: 0,
        padding: '20px 20px 20px 0',
        maxHeight: 210,
        overflow: 'auto',
        listStyle: 'none',
    },
    item: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingLeft: 4,
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        fontSize: 16,

        '& + &': {
            marginTop: 20,
        },
    },
    flag: {
        marginLeft: 8,
    },
    value: {
        maxWidth: 210,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    country: {
        fontFamily: theme.typographyPresets.fonts.notoSans.bold,
        fontWeight: 'bold',
    },
}))
